module.exports = __webpack_public_path__ + "static/img/pulverised.42fa5b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pulverised.png
// module id = 32ko
// module chunks = 1